var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-mobileMenu" }, [
    _c(
      "a",
      {
        staticClass: "toggle",
        class: _vm.mobileMenuOpen ? "active" : "",
        attrs: { href: "#" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.toggleMenu($event)
          }
        }
      },
      [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
    ),
    _vm._v(" "),
    _vm.mobileMenuOpen
      ? _c("nav", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "menuWrapper" }, [
            _c("div", { staticClass: "menu" }, [
              _c(
                "ul",
                { staticClass: "primary" },
                _vm._l(_vm.pageTree, function(page) {
                  return _c("li", { key: page.id }, [
                    _c(
                      "a",
                      { staticClass: "menu", attrs: { href: page.url } },
                      [_vm._v(_vm._s(page.title))]
                    ),
                    _vm._v(" "),
                    page.children
                      ? _c(
                          "ul",
                          { staticClass: "second" },
                          _vm._l(page.children, function(child) {
                            return _c("li", { key: child.id }, [
                              _c("a", { attrs: { href: child.url } }, [
                                _vm._v(_vm._s(child.title))
                              ])
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("div", { staticClass: "c-primaryLogo" }, [
        _c("a", { attrs: { href: "/" } }, [_vm._v("[LOGO]")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }